import { lazy, Suspense } from 'react'

import { createFileRoute, retainSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { graylogQueries } from '@/features/graylog/queries'

import { getCurrentTenant } from '@/shared/auth/store'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import { ErrorBoundary } from '@/components/common/error-boundary'

const TriggeredAlertsPage = lazy(
	() => import('@/features/graylog/triggered-alerts/components/page'),
)

const searchSchema = z.object({
	q: z.string().optional(),
})

export const Route = createFileRoute('/_dashboard/graylog/triggered-alerts')({
	validateSearch: zodValidator(searchSchema),

	search: {
		middlewares: [retainSearchParams(['q'])],
	},

	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		if (tenant) {
			queryClient.prefetchQuery(graylogQueries.triggeredAlerts(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Triggered Alerts | Graylog | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePending,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<div className="flex w-full flex-col items-start justify-start gap-6">
			<ErrorBoundary feature="triggered-alerts">
				<Suspense
					fallback={
						<TableFullSkeleton
							className="w-full"
							rows={10}
							withLastUpdated
							withFilters
						/>
					}
				>
					<TriggeredAlertsPage />
				</Suspense>
			</ErrorBoundary>
		</div>
	)
}

function RoutePending() {
	return (
		<div className="flex w-full flex-col items-start justify-start gap-6">
			<TableFullSkeleton
				className="w-full"
				rows={10}
				withLastUpdated
				withFilters
			/>
		</div>
	)
}
